export const transformBenefitsList = (benefits: string | string[]): string[] => {
    if (Array.isArray(benefits)) {
        return benefits
    }

    return (
        benefits
            ?.split(/\r?\n/)
            .filter(benefit => benefit.trim() !== "")
            .map(benefit => benefit.trim()) ?? []
    )
}
